import { useApiStore } from '@core/store/apiRequest/apiRequest'

import { ApiProfileStoreShape } from '@dashboard/modules/ProfileSelector/declarations'

export const useApiProfileStore = useApiStore<'apiProfile', ApiProfileStoreShape>('apiProfile')
